import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Gift, CheckCircle } from 'lucide-react';
const bonuses = [{
  title: '52-WEEK SEASON ROADMAP',
  image: 'https://cdn.magicpatterns.com/uploads/gh3y3epAGEis9r1472FGwn/bono_1_(8).webp',
  lines: ['A complete week-by-week implementation guide showing exactly how to use all six volumes throughout an entire basketball season.']
}, {
  title: 'BASKETBALL TRYOUT SYSTEM',
  image: 'https://cdn.magicpatterns.com/uploads/7FZviUsqdVnVL2b1kaL3n2/bono_2_(8).webp',
  lines: ['Professional player evaluation tools, selection frameworks, assessment sheets, and decision-making systems for building stronger teams.']
}, {
  title: 'GAME DAY SUCCESS SYSTEM',
  image: 'https://cdn.magicpatterns.com/uploads/fBr9J6AASUYpEwfpK48o74/bono_3_(7).webp',
  lines: ['A complete coaching system for game day preparation, warm-ups, halftime adjustments, timeouts, post-game evaluations, and match management.']
}, {
  title: 'BASKETBALL CAMP BLUEPRINT',
  image: 'https://cdn.magicpatterns.com/uploads/wk9bFZ7qQD4hsdrd66GvkB/bono_4_(8).webp',
  lines: ['Everything you need to organize successful basketball camps, clinics, player development events, and seasonal programs.']
}, {
  title: 'TEAM CULTURE PLAYBOOK',
  image: 'https://cdn.magicpatterns.com/uploads/oZkYmgK371CyXQmtHnVNhU/bono_5_(8).webp',
  lines: ['A complete leadership guide for building trust, accountability, communication, motivation, and a winning basketball culture.']
}];
export function Bonuses() {
  return <section className="relative border-y border-navy-800 bg-navy-900 py-12 md:py-24" data-id="element-15">
      <div className="container relative z-10 mx-auto px-4" data-id="element-16">
        <div className="mx-auto mb-10 max-w-3xl text-center md:mb-16" data-id="element-17">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-full bg-gold-500/20 text-gold-500 md:mb-6 md:h-16 md:w-16" data-id="element-18">
            <Gift className="h-6 w-6 md:h-8 md:w-8" data-id="element-19" />
          </motion.div>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mb-5 font-anton text-3xl uppercase tracking-wide text-white sm:text-4xl md:mb-6 md:text-6xl" data-id="element-20">
            5 BONUSES INCLUDED
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-gray-300 sm:text-xl" data-id="element-21">
            And you&apos;ll also receive 5 premium bonuses. Exclusive coaching
            resources that will transform your coaching workflow —{' '}
            <span className="font-bold text-green-400" data-id="element-22">
              included FREE today.
            </span>
          </motion.p>
        </div>

        <div className="mx-auto max-w-4xl space-y-4 md:space-y-6" data-id="element-23">
          {bonuses.map((bonus, index) => <motion.article key={bonus.title} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group relative flex flex-col items-start gap-4 overflow-hidden rounded-xl border border-navy-700 bg-navy-950 p-4 md:flex-row md:items-center md:gap-6 md:p-8" data-id="element-24">
              <div className="absolute bottom-0 left-0 top-0 w-2 bg-gradient-to-b from-gold-400 to-gold-600" data-id="element-25" />
              <div className="group relative mx-auto w-full max-w-[220px] flex-shrink-0 md:mx-0 md:w-44 md:max-w-none lg:w-52" data-id="element-26">
                <img src={bonus.image} alt={`Bonus ${index + 1} — ${bonus.title}`} loading="lazy" decoding="async" className="relative h-auto w-full rounded-lg border border-navy-700/50 shadow-2xl" data-id="element-27" />
                <div className="absolute left-2 top-2 rounded-md bg-gold-500 px-2.5 py-1 font-anton text-sm text-navy-950 shadow-lg" data-id="element-28">
                  #{index + 1}
                </div>
              </div>
              <div className="flex-grow" data-id="element-29">
                <div className="mb-1 font-oswald text-xs tracking-wide text-gold-500" data-id="element-30">
                  BONUS #{index + 1}
                </div>
                <h3 className="mb-4 font-oswald text-xl uppercase tracking-normal text-white sm:text-2xl sm:tracking-wide" data-id="element-31">
                  {bonus.title}
                </h3>
                <ul className="space-y-2" data-id="element-32">
                  {bonus.lines.map(line => <li key={line} className="flex items-start gap-2 text-sm leading-5 text-gray-400" data-id="element-33">
                      <CheckCircle className="mt-0.5 h-5 w-5 flex-shrink-0 text-green-500" data-id="element-34" />
                      <span data-id="element-35">{line}</span>
                    </li>)}
                </ul>
              </div>
            </motion.article>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mx-auto mt-8 max-w-3xl rounded-xl border border-navy-700 bg-navy-800/50 p-4 text-center md:mt-16 md:p-8" data-id="element-36">
          <h4 className="mb-2 font-oswald text-2xl uppercase tracking-widest text-white" data-id="element-37">
            Everything Included In
          </h4>
          <h3 className="mb-4 font-anton text-3xl uppercase tracking-wide text-gold-500 md:text-4xl" data-id="element-38">
            BASKETBALL READY: SYSTEM 365
          </h3>
          <p className="text-lg font-bold text-green-400" data-id="element-39">
            All 5 bonuses are included FREE with your purchase today.
          </p>
        </motion.div>
      </div>
    </section>;
}